module.exports = __webpack_public_path__ + "img/aboutUs_pic1.2e8e3dae.png";